import { UTMParameters, VALID_UTM_KEYS, getFirstTouchUTM, getLastTouchUTM, hasUTMParameters } from './attribution';

export const getUTMFromURL = (): UTMParameters => {
  const urlParams = new URLSearchParams(window.location.search);
  const utm: UTMParameters = {};

  VALID_UTM_KEYS.forEach(key => {
    const value = urlParams.get(key);
    if (value) {
      utm[key] = value;
    }
  });

  // SM-309 (EDD §5.7): legacy links carry a bare `source` param that no layer
  // ever read — promote it to utm_source when the URL has no utm_source of its
  // own. utm_source only (the other params have no legacy equivalent); first
  // touch is unaffected since this function feeds last-touch resolution only.
  if (!utm.utm_source) {
    const legacySource = urlParams.get('source');
    if (legacySource) {
      utm.utm_source = legacySource;
    }
  }

  return utm;
};

export const getInitialUTMProperties = (utm: UTMParameters): Record<string, string> => {
  const props: Record<string, string> = {};
  if (utm.utm_source) props['initial_utm_source'] = utm.utm_source;
  if (utm.utm_medium) props['initial_utm_medium'] = utm.utm_medium;
  if (utm.utm_campaign) props['initial_utm_campaign'] = utm.utm_campaign;
  if (utm.utm_content) props['initial_utm_content'] = utm.utm_content;
  if (utm.utm_term) props['initial_utm_term'] = utm.utm_term;
  if (utm.utm_id) props['initial_utm_id'] = utm.utm_id;
  return props;
};

export const getLastTouchUTMProperties = (utm: UTMParameters): Record<string, string> => {
  const props: Record<string, string> = {};
  if (utm.utm_source) props['utm_source'] = utm.utm_source;
  if (utm.utm_medium) props['utm_medium'] = utm.utm_medium;
  if (utm.utm_campaign) props['utm_campaign'] = utm.utm_campaign;
  if (utm.utm_content) props['utm_content'] = utm.utm_content;
  if (utm.utm_term) props['utm_term'] = utm.utm_term;
  if (utm.utm_id) props['utm_id'] = utm.utm_id;
  return props;
};

export const getAttributionFromURLOrCookie = (): {
  firstTouch: UTMParameters;
  lastTouch: UTMParameters;
} => {
  const urlParams = getUTMFromURL();
  const cookieFirstTouch = getFirstTouchUTM();
  const cookieLastTouch = getLastTouchUTM();

  return {
    firstTouch: cookieFirstTouch,
    lastTouch: hasUTMParameters(urlParams) ? urlParams : cookieLastTouch,
  };
};

export const getAttributionEventProperties = (): Record<string, string> => {
  const { firstTouch, lastTouch } = getAttributionFromURLOrCookie();

  return {
    ...getInitialUTMProperties(firstTouch),
    ...getLastTouchUTMProperties(lastTouch),
  };
};
